<template>
  <div id="Themestore_ski">
    <!-- 메인 배너 -->
    <div class="ski_mainwrap">
      <div class="ski_title">
        <img src="@/assets/img/themestore_ski/ski_title2.png" alt="스키 타이틀" />
      </div>
    </div>

    <!-- 서브 타이틀 -->
    <div class="ski_sub_title1" style="margin-bottom: 30px;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title1.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title1m.jpg" alt="">
    </div>

    <!-- Slick 캐러셀 -->
    <div class="spacial_carousel">
      <div class="autoplay">
        <div
          class="spacial_carousel_item"
          v-for="(item, index) in items"
          :key="index"
          @click="goToDetail(item.productId, item.salesRoute)"
        >
          <img :src="item.img" alt="스키이미지" />
        </div>
      </div>

      <button class="prev-btn" @click="prevSlide"></button>
      <button class="next-btn" @click="nextSlide"></button>
    </div>

    <!-- BEST 상품 섹션 -->
     <div class="max-bg-skitour ski_section1" style="background-color: #033d86;">
    <div class="ski_sub_title1" style="background-color: #033d86; margin-top: 30px">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title2.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title2m.jpg" alt="">
    </div>
      <img class="saleskintabi" src="../assets/img/themestore_ski/saleskintabi.png" alt="">
    </div>

     <div class="ski_sec3 ski_section2" style="margin:0 auto;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sec3_bg.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_productimg.jpg" alt="">
     </div>
    
     <div class="ski_sub_title1 skisubtitlepadding ski_section3">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title4.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title4m.jpg" alt="">
    </div>
    <div class="max-bg-skitour">
      <img class="saleskintabi" src="../assets/img/themestore_ski/skitime1.jpg" alt="">
    </div>
    <div class="ski_sub_title1 skisubtitlepadding ski_section4">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title5.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title5m.jpg" alt="">
    </div>
    <div class="max-bg-skitour">
      <img class="saleskintabi" src="../assets/img/themestore_ski/skitime2.jpg" alt="">
    </div>
    <div class="ski_sub_title1 skisubtitlepadding ski_section5" style="margin-top: 30px; background-color: #033d86;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title6.jpg" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title6m.jpg" alt="">
    </div>
    <div class="max-bg-skitour skitime2">
    <img class="saleskintabi ski-vertical" style="margin-bottom: 50px;" src="../assets/img/themestore_ski/skitime3.png" alt="">
    <img class="saleskintabi ski-vertical" src="../assets/img/themestore_ski/skitime4.png" alt="">
    </div>

    <div class="ski_sub_title1 skisubtitlepadding ski_section6">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title4-5.png" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title4-5m.png" alt="">
    </div>

    <div class="max-bg-skitour skitime2" style="background-color: #fff;">
      <a href="https://jrhokkaidonorikae.com/vtime/vtime.php?s=130" style="margin-bottom: 20px;">
<img class="saleskintabi" src="../assets/img/themestore_ski/ski_train1.png" alt="">
      </a>
      <a href="https://jrhokkaidonorikae.com/vtime/vtime.php?s=131">
 <img class="saleskintabi" src="../assets/img/themestore_ski/ski_train2.png" alt="">
      </a>
     </div>

     <div class="max-bg-skitour ski_section7 ski_center" style="background-color: #f4eddf; padding: 0;">
      <div class="hotellinetopbottom"></div>
      <div class="ski_sub_title1 skisubtitlepadding ski_section6" style="padding-top: 100px; margin-top: 0;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title7.png" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title7m.png" alt="" style="margin-bottom: 30px;">
    </div>
      <img class="saleskintabi ski_hotel" src="../assets/img/themestore_ski/hotel1.png" alt="" style="margin-bottom: 30px;">
      <img class="saleskintabi ski_hotel" src="../assets/img/themestore_ski/hotel2.png" alt="" style="margin-bottom: 30px;">
      <img class="saleskintabi ski_hotel" src="../assets/img/themestore_ski/hotel3.png" alt="" style="margin-bottom: 30px;">
      <div class="hotellinetopbottom" style="margin-top: 50px; margin-bottom:0px;"></div>
    </div>

   <div class="max-bg-skitour ski_section8 ski_center" style="background-color: #033d86; padding: 0; margin: 0 auto;">
      <div class="ski_sub_title1 skisubtitlepadding ski_section6" style="padding-top: 100px; margin-top: 0;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title8.jpg" style="margin-bottom: 50px;" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title8m.jpg" alt="" style="margin-bottom: 30px;">
    </div>
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_besttourplace.png" style="margin-bottom: 50px;" alt="">
      <div class="skitime2" style="flex-wrap: wrap; justify-content: start; margin: 0 auto;">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place1.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place2.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place3.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place4.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place5.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place6.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place7.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place8.png" style="margin-bottom: 30px;" alt="">            
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place9.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_touch" src="../assets/img/themestore_ski/ski_place10.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_startflex" src="../assets/img/themestore_ski/ski_place9.png" style="margin-bottom: 30px;" alt="">
      <img class="ski_sub_pc ski_startflex" src="../assets/img/themestore_ski/ski_place10.png" style="margin-bottom: 30px;" alt="">
      </div>
    </div>

    <div class="ski_sub_title1 skisubtitlepadding ski_section9" style="padding-top: 100px; margin-top: 0;">
      <img class="ski_sub_pc" src="../assets/img/themestore_ski/ski_sub_title9.jpg" style=" margin: 0 auto 50px auto;" alt="">
      <img class="ski_sub_m" src="../assets/img/themestore_ski/ski_sub_title9m.jpg"  alt="" style="margin-bottom: 30px; margin: 0 auto;">
    </div>

<div class="max-bg-skitour ski_center" style="background-color: #00d2ff;">
      
      <img class="ski_sub_pc ski_hotel ski_bottom" src="../assets/img/themestore_ski/model1.png" alt="">
      <img class="ski_sub_pc ski_hotel ski_bottom" src="../assets/img/themestore_ski/model2.png" alt="">
      <img class="ski_sub_pc ski_hotel ski_bottom" src="../assets/img/themestore_ski/model3.png" alt="">
      <!--<img class="ski_sub_pc ski_hotel" src="../assets/img/themestore_ski/model4.png" alt="">-->
      <img class="ski_sub_m" src="../assets/img/themestore_ski/model_2.png" alt="">
      
      <a class="ski_bottom_button" href="javascript:void(0)" @click="goToDetail('L-20251124-1763944902911','L')">상품 보기</a>
    </div>

    </div>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'ThemestoreSki',

  data() {
    return {
      $slider: null,
      items: [
        { img: require('@/assets/img/themestore_ski/ski_cos0.png'), productId: 'L-20251124-1763944902911', salesRoute: 'L'},
        { img: require('@/assets/img/themestore_ski/ski_cos1.png'), productId: '/ski_section1'},
        { img: require('@/assets/img/themestore_ski/ski_cos2.png'), productId: '/ski_section2'},
        { img: require('@/assets/img/themestore_ski/ski_cos3.png'), productId: '/ski_section3' },
        { img: require('@/assets/img/themestore_ski/ski_cos4.png'), productId: '/ski_section4' },
        { img: require('@/assets/img/themestore_ski/ski_cos5.png'), productId: '/ski_section5' },
        { img: require('@/assets/img/themestore_ski/ski_cos6.png'), productId: '/ski_section6' },
        { img: require('@/assets/img/themestore_ski/ski_cos7.png'), productId: '/ski_section7' },
        { img: require('@/assets/img/themestore_ski/ski_cos8.png'), productId: '/ski_section8' },
        { img: require('@/assets/img/themestore_ski/ski_cos9.png'), productId: '/ski_section9' },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      // slick 초기화
      this.initSlick()
    })
  },

  beforeUnmount() {
    if (this.$slider && this.$slider.hasClass('slick-initialized')) {
      this.$slider.slick('unslick')
    }
  },

  methods: {
    initSlick() {
      const slider = $('.autoplay')
      if (slider.hasClass('slick-initialized')) slider.slick('unslick')

      const isMobile = window.innerWidth <= 1024
      slider.slick({
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        infinite: true,
        centerMode: isMobile,
        centerPadding: isMobile ? '10%' : '0',
      })

      this.$slider = slider
    },

    nextSlide() {
      if (this.$slider) this.$slider.slick('slickNext')
    },

    prevSlide() {
      if (this.$slider) this.$slider.slick('slickPrev')
    },

    goToDetail(productId, salesRoute) {
  if (productId && productId.startsWith('/ski_section')) {
    const sectionClass = productId.replace('/', '')
    const target = document.querySelector(`.${sectionClass}`)

    if (target) {
      const offset = target.getBoundingClientRect().top + window.scrollY - 80
      window.scrollTo({ top: offset, behavior: 'smooth' })
    }
    return
  }

  this.$router.push({
    path: "/detail",
    query: { productId, salesRoute },
  })
}
  },
}
</script>


<style scoped>

#Themestore_ski { margin-top: -56px;
}

.ski_mainwrap {
  margin: 0 auto 100px auto;
  max-width: 2000px;
  background-color: black;
  height: 800px;
  background: url(../assets/img/themestore_ski/ski_bg.jpg) center no-repeat;
}

.ski_main_design {
  position: absolute;
  z-index: 3;
  width: 25vw;
  max-width: 600px;
  min-width: 300px;
  top: 200px;
  left: 64%;
  transform: translateX(88%);
  transition: transform 1.5s ease;
}

.ski_main_design.entered {
  transform: translateX(-30%);
}

@media(max-width: 1920px){
  .ski_main_design.entered {
    transform: translateX(-18%);
  }
}

.max-bg-skitour{
    padding: 100px 0;
    text-align: center;
    max-width: 2000px;
    margin: 0 auto;
  }
.ski_title {
  position: absolute;
  z-index: 2;
  width: 700px;
  height: 700px;
  top: 210px;
  left: 50%;
  transform: translateX(-50%);
  animation: ski 0.5s;
}
@keyframes ski{
  0%{scale: 0.3;}
  50%{scale: 1.2;}
  100%{scale: 1;}
}
.ski_sub_title1{
  text-align: center;
  margin: 0 auto 0px auto;
  max-width: 2000px;
}

.ski_sub_m{
    display: none;
  }
  .ski_sub_pc{
    display: block;
    margin: 0 auto;
  }

.spacial_carousel {
  position: relative;
  margin: 0 auto 100px auto;
  max-width: 1200px;
}

.autoplay .slick-slide {
  padding: 0 15px;
  box-sizing: border-box;
  pointer-events: none;
}

.spacial_carousel_item {
  pointer-events: auto;
  cursor: pointer;
  padding: 0 5%;
}

.spacial_carousel_item img {
  width: 100%;
  height: 500px;
  object-fit: cover;
  border-radius: 20px;
}

.prev-btn, .next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border: solid #d6d6d6 0.5px;
  cursor: pointer;
  z-index: 10;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prev-btn{
  left: -70px;
  background: url(../assets/img/themestore_ski/left.jpg) no-repeat center;
  background-size: 70%;
}

.next-btn{
  right: -70px;
  background: url(../assets/img/themestore_ski/right.jpg) no-repeat center;
  background-size: 70%;
}

.slick-dots {
  bottom: -30px;
}

.slick-dots li button:before {
  font-size: 30px;
  color: #c7c7c7;
  opacity: 1;
}

.slick-dots li.slick-active button:before {
  color: #333;
}

.saleskintabi{
  transition: all 0.2s;
}
.saleskintabi:hover{
  scale: 1.03;
}

.ski_sec3{
  max-width: 2000px;
  margin: 0 auto;
}
.ski_sec3 img{
  width: 100%;
}
.ski_in_tour{
  border-radius: 15px;
  width: 100%;
  height: 350px;
}

.skisubtitlepadding{
  padding: 200px 0 30px 0;
}
.skitime2{
  background-color: #033d86;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 0 100px 100px 100px;
}
.hotellinetopbottom{
  width: 300px;
  height: 30px;
  background-color:#985c1c;
  margin:0 auto 50px auto;
}
.ski_center{
  display: flex;
  flex-direction: column;
}
.ski_hotel{
  margin: 0 auto;
  width: 50%;
}
.ski_bottom_button{
  margin: 0 auto;
  width: 300px;
  height: 100px;
  padding-top: 2rem;
  font-size: 25px;
  font-weight: bold;
  background-color: #033d86;
  color: #fff;
  border-radius: 12px;
  transition: all 0.2s;
}
.ski_bottom_button:hover{
  transform: scale(1.03);
}
@media (max-width: 1024px) {
  .skisubtitlepadding{
    padding: 30px 0 10px 0 !important; 
    margin-top: 10px;
  }
  .ski_mainwrap {
    height: 600px;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
  }

  .ski_main_design {
    width: 45vw;
    top: 140px;
    left: 65%;
    transform: translateX(80%);
    z-index: 1;
  }

  .ski_title { 
    width: 90%;
    top: 180px;
    left: 50%;
    transform: translateX(-50%);
  }
  .ski_title img {
    width: 100%; height: auto;
  }
  .ski_sub_title1{
     margin-top: 50px; 
  }
  .ski_sub_title1 img {
    width: 100%; height: auto;
  }

  .spacial_carousel {
    max-width: 100%;
  }
  .autoplay .slick-slide {
    padding: 0 5px;
  }
  .spacial_carousel_item img {
    width: 100%;
    height: 420px;
    object-fit: cover;
    border-radius: 15px;
  }

  .prev-btn, .next-btn {
    display: none !important;
  }

  .ski_sub_m{
    display: block;
  }
  .ski_sub_pc{
    display: none;
  }
  .saleskintabi{
    width: 94%;
  }
  .max-bg-skitour{
    padding: 20px 0 40px 0;
  }
  .skitime2{
    margin: 0 auto;
    flex-direction: column;
    justify-content: start;
    padding-bottom: 70px;
}
.skitime2 img{
    margin: 0 auto;
}
.hotellinetopbottom{
  width: 200px;
  height: 15px;
  background-color:#985c1c;
  margin:0 auto 50px auto;
}
.ski_bottom{
  margin-bottom:3 0px;
}
.ski_bottom_button{
  margin-top: 50px;
  width: 60%;
  height: 60px;
  padding-top: 15px;
  font-size: 1.2rem;
}
}
.ski_startflex{
  opacity: 0;
  margin: 0 auto;
}
.ski_touch{
  transition: 0.3s all;
}
.ski_touch:hover{
  transform: translateY(-10px);
}
.ski_bottom{
  margin-bottom:100px;
}

</style>
